import { render, staticRenderFns } from "./NoticeListItem.vue?vue&type=template&id=5a488010&scoped=true"
import script from "./NoticeListItem.vue?vue&type=script&lang=ts"
export * from "./NoticeListItem.vue?vue&type=script&lang=ts"
import style0 from "./NoticeListItem.vue?vue&type=style&index=0&id=5a488010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a488010",
  null
  
)

export default component.exports